import * as React from 'react'

const SvgTextBoldIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.406 15.625H5.625V4.375h5.313a3.281 3.281 0 012.5 5.406 3.281 3.281 0 01-2.032 5.844zM7.5 13.75h3.894a1.406 1.406 0 100-2.813H7.5v2.813zm0-4.688h3.438a1.406 1.406 0 000-2.812H7.5v2.813z"
      fill="#163250"
    />
  </svg>
)

export default SvgTextBoldIcon
